import React from "react"
import { View, Text, StyleSheet } from "react-native"
import { theme } from "@common/theme/theme"

/**
 * « 1 · Quelles matières ? » — la pastille numérotée et la question d'une
 * étape d'un compositeur. Le numéro est une pastille, pas un chiffre perdu
 * dans la phrase : c'est lui qui remplace la phrase d'explication.
 */
const FunnelStepBullet = ({ n, label }) => (
    <View style={styles.step}>
        <View style={styles.bullet}>
            <Text style={styles.bulletText}>{n}</Text>
        </View>
        <Text style={styles.label}>{label}</Text>
    </View>
)

const styles = StyleSheet.create({
    step: {
        flexDirection: "row",
        alignItems: "center",
        gap: 9,
        marginTop: 26,
        marginBottom: 12,
    },
    bullet: {
        width: 22,
        height: 22,
        borderRadius: 22,
        backgroundColor: theme.colors.primary,
        alignItems: "center",
        justifyContent: "center",
    },
    bulletText: {
        fontFamily: "Montserrat-ExtraBold",
        fontSize: 11.5,
        color: theme.colors.white,
    },
    label: {
        flex: 1,
        fontFamily: "Montserrat-Bold",
        fontSize: 15,
        color: theme.colors.primaryDark || theme.colors.primary,
    },
})

export default FunnelStepBullet
